import { UserType } from '@/entities/user'
import { apiClient, Auth } from '@/shared/api'

import { TContractMmpEvents } from './schema'

type GetContractMmpEventsParams = {
  userType: UserType
}

export const getContractMmpEvents = async ({
  userType,
}: GetContractMmpEventsParams) => {
  const response = await apiClient.get<TContractMmpEvents>({
    endpoint: `/${userType}/contracts/mmp-events`,
    auth: Auth.REQUIRED,
  })

  return response
}
